<template>
    <div class="field">
        <p class="control has-icons-left">
            <input :class="[{ 'is-danger': errors.has($attrs['data-vv-name']) }, 'input']"
                   maxlength="5"
                   placeholder="00/00"
                   v-bind="$attrs"
                   v-validate="'required|cardDate'"
                   ref="input"
                   @input="handleInputChange" />
            <span class="icon is-small is-left">
                <i class="fa fa-calendar"></i>
            </span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "card-date",
        inject: ["$validator"],
        props: {
            inputValue: { required: true, default: "" }
        },
        data: () => ({ value: null, displayValue: null }),
        created() {
            this.$validator.extend("cardDate", {
                getMessage: () => this.$t("payment system.validation.card date.format"),
                validate: () => this.validate()
            });
        },
        methods: {
            handleInputChange() {
                this.value = this.$refs.input.value.replace(/\D/g, "");
                this.$refs.input.value = this.value
                    .split(/(.{2})/)
                    .filter(item => item)
                    .join("/");
                this.$emit("update:inputValue", this.value);
            },
            validate() {
                const [inputMonth, inputYear, date] = [...this.$refs.input.value.split("/").map(item => +item), new Date()];
                const month = date.getMonth() + 1;
                const year = +date.getFullYear().toString().slice(2);

                return inputMonth > 0 && inputMonth < 13 && (inputYear > year || inputYear === year && inputMonth >= month);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/payments/card-date.vue